<template>
<div class="Circles">
    <svg version="1.1" id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1030.9 1026" enable-background="new 0 0 1030.9 1026" xml:space="preserve">
        <g>
            <path fill="none" d="M859.9,684c0,94.4-76.6,171-171,171c94.4,0,171,76.6,171,171c0-94.4,76.6-171,171-171

C936.4,855,859.9,778.4,859.9,684z" />
            <path fill="none" d="M346.9,171c94.4,0,171,76.6,171,171c0-94.4,76.6-171,171-171c-94.4,0-171-76.6-171-171

C517.9,94.4,441.3,171,346.9,171z" />
            <circle fill="none" cx="688.9" cy="342" r="146.6" />
            <path fill="none" d="M859.9,342c0,94.4-76.6,171-171,171c94.4,0,171,76.6,171,171c0-94.4,76.6-171,171-171

C936.4,513,859.9,436.4,859.9,342z" />
            <path fill="none" d="M346.9,171c-94.4,0-171-76.6-171-171c0,94.4-76.6,171-171,171c94.4,0,171,76.6,171,171

C175.9,247.6,252.4,171,346.9,171z" />
            <path fill="none" d="M859.9,0c0,94.4-76.6,171-171,171c94.4,0,171,76.6,171,171c0-94.4,76.6-171,171-171

C936.4,171,859.9,94.4,859.9,0z" />
            <path fill="none" d="M688.9,513c-94.4,0-171-76.6-171-171c0,94.4-76.6,171-171,171c94.4,0,171,76.6,171,171

C517.9,589.6,594.4,513,688.9,513z" />
            <path fill="#FFFFFF" d="M175.9,0h-24.4c0,80.9-65.6,146.6-146.6,146.6V171C99.3,171,175.9,94.4,175.9,0z" />
            <path fill="#FFFFFF" d="M4.9,171v24.4c80.9,0,146.6,65.6,146.6,146.6h24.4C175.9,247.6,99.3,171,4.9,171z" />
            <path fill="#FFFFFF" d="M346.9,171c94.4,0,171-76.6,171-171h-24.4c0,80.9-65.6,146.6-146.6,146.6S200.3,80.9,200.3,0h-24.4

C175.9,94.4,252.4,171,346.9,171z" />
            <path fill="#FFFFFF" d="M517.9,342c0,94.4,76.6,171,171,171s171-76.6,171-171c0-94.4-76.6-171-171-171S517.9,247.6,517.9,342z

 M688.9,195.4c80.9,0,146.6,65.6,146.6,146.6c0,80.9-65.6,146.6-146.6,146.6S542.3,422.9,542.3,342

C542.3,261.1,607.9,195.4,688.9,195.4z" />
            <path fill="#FFFFFF" d="M688.9,171c94.4,0,171-76.6,171-171h-24.4c0,80.9-65.6,146.6-146.6,146.6S542.3,80.9,542.3,0h-24.4

C517.9,94.4,594.4,171,688.9,171z" />
            <path fill="#FFFFFF" d="M859.9,342c0,94.4,76.6,171,171,171v-24.4c-80.9,0-146.6-65.6-146.6-146.6c0-80.9,65.6-146.6,146.6-146.6

V171C936.4,171,859.9,247.6,859.9,342z" />
            <path fill="#FFFFFF" d="M884.3,0h-24.4c0,94.4,76.6,171,171,171v-24.4C949.9,146.6,884.3,80.9,884.3,0z" />
            <path fill="#FFFFFF" d="M517.9,342c0-94.4-76.6-171-171-171s-171,76.6-171,171h24.4c0-80.9,65.6-146.6,146.6-146.6

S493.5,261.1,493.5,342c0,80.9-65.6,146.6-146.6,146.6V513C441.3,513,517.9,436.4,517.9,342z" />
            <path fill="#FFFFFF" d="M346.9,513v24.4c80.9,0,146.6,65.6,146.6,146.6h24.4C517.9,589.6,441.3,513,346.9,513z" />
            <path fill="#FFFFFF" d="M859.9,684c0,94.4,76.6,171,171,171v-24.4c-80.9,0-146.6-65.6-146.6-146.6s65.6-146.6,146.6-146.6V513

C936.4,513,859.9,589.6,859.9,684z" />
            <path fill="#FFFFFF" d="M859.9,684c0-94.4-76.6-171-171-171s-171,76.6-171,171h24.4c0-80.9,65.6-146.6,146.6-146.6

S835.5,603.1,835.5,684s-65.6,146.6-146.6,146.6V855C783.3,855,859.9,778.4,859.9,684z" />
            <path fill="#FFFFFF" d="M688.9,855v24.4c80.9,0,146.6,65.6,146.6,146.6h24.4C859.9,931.6,783.3,855,688.9,855z" />
            <path fill="#FFFFFF" d="M859.9,1026h24.4c0-80.9,65.6-146.6,146.6-146.6V855C936.4,855,859.9,931.6,859.9,1026z" />
        </g>
    </svg>
</div>
</template>

<script>
export default {
    name: "Circles"
};
</script>

<style scoped>
</style>
